// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2ProcessingResultModel {
    static getAttributeTypeMap() {
        return EnrollmentV2ProcessingResultModel.attributeTypeMap;
    }
}
EnrollmentV2ProcessingResultModel.discriminator = undefined;
EnrollmentV2ProcessingResultModel.additionalProperties = false;
EnrollmentV2ProcessingResultModel.attributeTypeMap = [
    {
        "name": "enrollment",
        "baseName": "enrollment",
        "type": "EnrollmentV2EnrollmentModel"
    },
    {
        "name": "eligibilityResults",
        "baseName": "eligibilityResults",
        "type": ""
    },
    {
        "name": "allEligibilityResults",
        "baseName": "allEligibilityResults",
        "type": ""
    },
    {
        "name": "updateCaseId",
        "baseName": "updateCaseId",
        "type": "number"
    },
    {
        "name": "memberNumbersResult",
        "baseName": "memberNumbersResult",
        "type": ""
    },
    {
        "name": "relatedAccumulatorId",
        "baseName": "relatedAccumulatorId",
        "type": "number"
    },
    {
        "name": "evaluationResult",
        "baseName": "evaluationResult",
        "type": "EnrollmentV2ProcessingOutcomeModel"
    },
    {
        "name": "benefitResult",
        "baseName": "benefitResult",
        "type": "EnrollmentV2ProcessingBenefitModel"
    },
    {
        "name": "metaRuleResults",
        "baseName": "metaRuleResults",
        "type": ""
    },
    {
        "name": "memberNumberBucketResults",
        "baseName": "memberNumberBucketResults",
        "type": ""
    },
];
//# sourceMappingURL=enrollmentV2ProcessingResultModel.js.map